import React, {Component} from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import * as actions from './redux/actions/auth';
import * as employeeActions from './redux/actions/employee';
import { connect } from 'react-redux';

class Logout extends Component{
    componentDidMount(){
        this.props.onLogout();
        this.props.onClearData();
        this.props.onSetAuthRedirect();
    }
    render(){
        return (
            <Redirect to="/login"/>
        );
    }
}

const mapDispatchToProps=dispatch=>{
    return {
        onLogout:()=>dispatch(actions.logout()),
        onSetAuthRedirect:()=>dispatch(actions.setAuthRedirectPath("/login")),
        onClearData:()=>dispatch(employeeActions.clearData()),
    }
}
export default withRouter(connect(null,mapDispatchToProps)(Logout));